export interface OrganizationsByRoleModel {
  code: string;
  name: string;
  id?: number;
}
